module.exports = __webpack_public_path__ + "static/img/8.079029a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/video-group/8.jpg
// module id = lbRH
// module chunks = 1